import { Injectable } from '@angular/core';
import { map } from 'rxjs';

import { BrowseSorting } from '../../models/sorting';
import { Store } from '../../../../shared/store';
import { SortingState } from './sorting.state';

const sortingState = new SortingState();

@Injectable({ providedIn: 'root' })
export class SortingStore extends Store<SortingState> {
  videoSorting$ = this.state$.pipe(map((s) => s.videoSorting));
  playlistSorting$ = this.state$.pipe(map((s) => s.playlistSorting));
  gpsSorting$ = this.state$.pipe(map((s) => s.gpsSorting));
  workoutSorting$ = this.state$.pipe(map((s) => s.workoutSorting));
  coachingSorting$ = this.state$.pipe(map((s) => s.coachingSorting));
  searchedContentSorting$ = this.state$.pipe(
    map((s) => s.searchedContentSorting)
  );

  constructor() {
    super(sortingState);
  }

  setVideoSorting(nextVideoSorting: BrowseSorting): void {
    this.setState({ ...this.state, videoSorting: nextVideoSorting });
  }

  setPlaylistSorting(nextPlaylistSorting: BrowseSorting): void {
    this.setState({ ...this.state, playlistSorting: nextPlaylistSorting });
  }

  setGpsSorting(nextGpsSorting: BrowseSorting): void {
    this.setState({ ...this.state, gpsSorting: nextGpsSorting });
  }

  setWorkoutSorting(nextWorkoutSorting: BrowseSorting): void {
    this.setState({ ...this.state, workoutSorting: nextWorkoutSorting });
  }

  setCoachingSorting(nextCoachingSorting: BrowseSorting): void {
    this.setState({ ...this.state, coachingSorting: nextCoachingSorting });
  }

  setSearchedContentSorting(nextSearchedContentSorting: BrowseSorting): void {
    this.setState({
      ...this.state,
      searchedContentSorting: nextSearchedContentSorting,
    });
  }
}
